export const checkIsIntegerNumber = (value: string) => (
  !!value && /^([0-9]+)$/.test(value)
);

export const checkIsFloatNumber = (value: string) => (
  !!value && (checkIsIntegerNumber(value) || /^(\d{1,}\.\d{0,})$/.test(value))
);